var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fluid-container footer"},[_c('p',{staticClass:"text-center",attrs:{"id":"footer-text"}},[_vm._v(" Copyright "+_vm._s(new Date().getFullYear())+" "+_vm._s(_vm.$appName ? _vm.$appName : "Reducer")+" Ltd ")])])}
var staticRenderFns = []

export { render, staticRenderFns }